function removeSearchInput() {
    if (window.innerWidth <= 768) return;

    const searchInput = document.querySelector('#searchInput');

    if (searchInput) {
        searchInput.remove();
        return true;
    }

    return false;
}

function clearButtonOnNoResultPage() {
  const backButton = document.querySelector(".custom-back-button");

  if (!backButton) return;

  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname;
  const hasQueryParams = currentUrl.search.length > 0;
  const backButtonText = backButton.querySelector('span');

  // Update button text
  if (pathname.includes("/collections/") && hasQueryParams) {
    backButtonText.textContent = "Clear Filter";
  } else if (pathname.includes("/pages/search")) {
    backButtonText.textContent = "Go Home Page";
  }

  // Handle click
  backButton.addEventListener("click", function () {
    if (pathname.includes("/collections/") && hasQueryParams) {
      window.location.href = window.location.origin + pathname;
    } else if (pathname.includes("/pages/search")) {
      window.location.href = window.location.origin;
    } else {
      // Default fallback
      window.history.back();
    }
  });
}


function isGridFilterElement(element) {
  if (!element || element.nodeType !== 1) return false;
  if (element.classList.contains('wizzy-result-product')) return false;
  return element.classList.contains('wizzy-grid-filters-box') ||
    element.classList.contains('wizzy-filters-facet-block') ||
    !!element.querySelector('.wizzy-grid-filters-box');
}

function getWizzyGridLevel() {
  var wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  if (!wrapper) return null;
  return parseInt(wrapper.getAttribute('wizzy-tile-view-level'), 10) || null;
}

function getCycleSizeForGridLevel(level) {
  if (level === 1) return 5;
  if (level === 2) return 2;
  if (level === 3) return 4;
  if (level === 4) return 6;
  return 2;
}

function getRowEndIndex(productIndex, cycleSize) {
  return Math.floor(productIndex / cycleSize) * cycleSize + (cycleSize - 1);
}

function markGridFilterOriginalPositions(list) {
  var products = Array.from(list.querySelectorAll(':scope > .wizzy-result-product'));

  Array.from(list.children).filter(isGridFilterElement).forEach(function(filter) {
    if (filter.dataset.wizzyOriginalAfter != null) return;

    var prev = filter.previousElementSibling;
    while (prev && !prev.classList.contains('wizzy-result-product')) {
      prev = prev.previousElementSibling;
    }
    if (!prev) return;

    var insertAfterIndex = products.indexOf(prev);
    if (insertAfterIndex !== -1) {
      filter.dataset.wizzyOriginalAfter = insertAfterIndex;
    }
  });
}

function moveGridFilterAfterProduct(list, filter, products, productIndex) {
  if (productIndex < 0 || productIndex >= products.length) return;

  var targetProduct = products[productIndex];
  if (!targetProduct || targetProduct.nextElementSibling === filter) return;

  targetProduct.insertAdjacentElement('afterend', filter);
}

function restoreGridFiltersToOriginal(list) {
  var products = Array.from(list.querySelectorAll(':scope > .wizzy-result-product'));
  var filters = Array.from(list.children).filter(isGridFilterElement);

  filters
    .map(function(filter) {
      return {
        filter: filter,
        originalIndex: parseInt(filter.dataset.wizzyOriginalAfter, 10)
      };
    })
    .filter(function(entry) {
      return !isNaN(entry.originalIndex);
    })
    .sort(function(a, b) {
      return a.originalIndex - b.originalIndex;
    })
    .forEach(function(entry) {
      products = Array.from(list.querySelectorAll(':scope > .wizzy-result-product'));
      moveGridFilterAfterProduct(list, entry.filter, products, entry.originalIndex);
    });
}

function repositionGridFiltersForLevel(list, level) {
  var cycleSize = getCycleSizeForGridLevel(level);
  var products = Array.from(list.querySelectorAll(':scope > .wizzy-result-product'));
  var filters = Array.from(list.children).filter(isGridFilterElement);

  filters.slice().reverse().forEach(function(filter) {
    var sourceIndex = parseInt(filter.dataset.wizzyOriginalAfter, 10);
    if (isNaN(sourceIndex)) {
      var prev = filter.previousElementSibling;
      while (prev && !prev.classList.contains('wizzy-result-product')) {
        prev = prev.previousElementSibling;
      }
      if (!prev) return;
      sourceIndex = products.indexOf(prev);
    }
    if (sourceIndex === -1) return;

    var snapIndex = getRowEndIndex(sourceIndex, cycleSize);
    if (snapIndex >= products.length) {
      snapIndex = products.length - 1;
    }

    products = Array.from(list.querySelectorAll(':scope > .wizzy-result-product'));
    moveGridFilterAfterProduct(list, filter, products, snapIndex);
  });
}

function applyTileLargeClasses(wrapper) {
  var products = wrapper.querySelectorAll('.wizzy-search-results-list > .wizzy-result-product');
  products.forEach(function(product, index) {
    product.classList.toggle('tile-large', index % 5 === 0);
  });
}

function removeTileLargeClasses(scope) {
  (scope || document).querySelectorAll('.wizzy-result-product.tile-large').forEach(function(product) {
    product.classList.remove('tile-large');
  });
}

function normalizeWizzyGridLayout() {
  var run = function() {
    var wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
    if (!wrapper) {
      removeTileLargeClasses();
      return;
    }

    var level = getWizzyGridLevel();
    var list = wrapper.querySelector('.wizzy-search-results-list');
    if (!list || !level) return;

    markGridFilterOriginalPositions(list);

    if (level === 1) {
      repositionGridFiltersForLevel(list, 1);
      applyTileLargeClasses(wrapper);
      return;
    }

    restoreGridFiltersToOriginal(list);
    removeTileLargeClasses(wrapper);
  };

  run();
  window.requestAnimationFrame(run);
}


// Try immediately
if (!removeSearchInput()) {
    const observer = new MutationObserver(() => {
        if (removeSearchInput()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

(function() {
  var MOBILE_BREAKPOINT = window.matchMedia('only screen and (max-width: 989px)');

  function isMobileSearch() {
    return MOBILE_BREAKPOINT.matches;
  }

  function getDesktopSearchContainer() {
    return document.querySelector('.st-search-autocomplete-desktop.site-nav__link');
  }

  function getDesktopSearchInput() {
    return document.querySelector('.st-search-bar.st-for-desktop .wizzy-search-input');
  }

  function isDesktopSearchOpen() {
    var container = getDesktopSearchContainer();
    return container && container.style.display === 'block';
  }

  function openDesktopSearch() {
    var container = getDesktopSearchContainer();
    if (!container) return;

    container.style.display = 'block';
    document.body.classList.add('st-no-scroll');

    var input = getDesktopSearchInput();
    if (input) {
      setTimeout(function() {
        input.focus();
      }, 100);
    }
  }

  function closeDesktopSearch() {
    var container = getDesktopSearchContainer();
    if (container) {
      container.style.display = 'none';
    }
    document.body.classList.remove('st-no-scroll');
  }

  function toggleDesktopSearch() {
    if (isDesktopSearchOpen()) {
      closeDesktopSearch();
    } else {
      openDesktopSearch();
    }
  }

  function closeWizzyFilterDrawer() {
    document.documentElement.classList.remove('wizzy-overlay-opened', 'wizzy-filters-overlay');
    document.body.classList.remove('wizzy-overlay-opened', 'wizzy-filters-overlay');

    document.querySelectorAll('.wizzy-filters-overlay').forEach(function(overlay) {
      overlay.classList.remove('wizzy-overlay-opened');
    });
  }

  function initWizzySearchUI() {
    document.querySelectorAll('.desktop_searchIcn').forEach(function(icon) {
      if (icon.dataset.wizzySearchBound === 'true') return;
      icon.dataset.wizzySearchBound = 'true';

      icon.addEventListener('click', function(e) {
        if (isMobileSearch()) return;
        e.preventDefault();
        toggleDesktopSearch();
      });
    });

    document.querySelectorAll('.st-search-close-icon, .close_search').forEach(function(btn) {
      if (btn.dataset.wizzySearchBound === 'true') return;
      btn.dataset.wizzySearchBound = 'true';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDesktopSearch();
      });
    });
  }

  function initWizzyFilterClose() {
    if (window.__wizzyFilterCloseBound) return;
    window.__wizzyFilterCloseBound = true;

    document.addEventListener('click', function(e) {
      var closeTarget = e.target.closest('.wizzy-filters-close-btn, .wizzy-filters-close-button');
      if (!closeTarget) return;
      closeWizzyFilterDrawer();
    });
  }

  function bootWizzySearchUI() {
    initWizzySearchUI();
    initWizzyFilterClose();
    placeCollectionSeoInWizzy();
    watchCollectionSeoSlot();
  }

  function watchCollectionSeoSlot() {
    if (window.__collectionSeoWatching) return;
    window.__collectionSeoWatching = true;
    var obs = new MutationObserver(function() {
      placeCollectionSeoInWizzy();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function bindCollectionSeoReadMore() {
    if (window.__collectionSeoReadMore) return;
    window.__collectionSeoReadMore = true;

    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('.read_toggle');
      if (!toggle) return;
      var wrapper = toggle.closest('.content_wrapper');
      if (!wrapper) return;

      var extra = wrapper.querySelector('.content > div.hide_content');
      var readmore = wrapper.querySelector('.readmore');
      var readless = wrapper.querySelector('.readless');
      if (!extra) return;

      if (toggle.classList.contains('readmore')) {
        extra.style.display = 'inline-block';
        if (readmore) readmore.style.display = 'none';
        if (readless) readless.style.display = 'inline-block';
      } else {
        extra.style.display = 'none';
        if (readless) readless.style.display = 'none';
        if (readmore) readmore.style.display = 'inline-block';
      }
    });
  }

  function getCollectionSeoHtml() {
    if (window.__collectionSeoHtml) return window.__collectionSeoHtml;

    var source = document.getElementById('collection-seo-source');
    if (source) {
      var tmp = document.createElement('div');
      tmp.appendChild(source.content.cloneNode(true));
      if (tmp.innerHTML.trim()) {
        window.__collectionSeoHtml = tmp.innerHTML;
        return window.__collectionSeoHtml;
      }
    }

    var seo = document.getElementById('collection-seo-content');
    if (seo) {
      window.__collectionSeoHtml = seo.outerHTML;
      return window.__collectionSeoHtml;
    }

    return '';
  }

  function placeCollectionSeoInWizzy() {
    bindCollectionSeoReadMore();

    var html = getCollectionSeoHtml();
    if (!html) return;

    var slot = document.getElementById('wizzy-collection-seo-slot');
    if (slot) {
      if (!slot.querySelector('#collection-seo-content')) {
        slot.innerHTML = html;
      }
      var section = document.querySelector('.shopify-section.collection-seo-content');
      if (section) section.style.display = 'none';
      return;
    }

    var wizzy = document.getElementById('wizzy-shopify-collection-page-wrapper');
    if (wizzy && !wizzy.querySelector('#collection-seo-content')) {
      wizzy.insertAdjacentHTML('beforeend', html);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWizzySearchUI);
  } else {
    bootWizzySearchUI();
  }

  window.bootWizzySearchUI = bootWizzySearchUI;
  window.placeCollectionSeoInWizzy = placeCollectionSeoInWizzy;
})();

window.onWizzyScriptLoaded = function() {
  function getAttributeValue(product, attrId) {
    if (!product.attributes) return '';

    var attribute = product.attributes.find(function(attr) {
      return attr.id === attrId;
    });

    if (!attribute || !attribute.values || !attribute.values.length) return '';

    var value = attribute.values[0].value;
    return Array.isArray(value) ? value[0] : value;
  }

  // badge_1..badge_5 from theme settings (window.wizzyProductBadges)
  var PRODUCT_BADGES = Array.isArray(window.wizzyProductBadges)
    ? window.wizzyProductBadges
    : [];

  function getProductTags(product) {
    var raw = getAttributeValue(product, 'product_tags');
    if (!raw) return [];

    return String(raw)
      .split(',')
      .map(function(tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function productHasTag(product, tag) {
    var needle = String(tag).toLowerCase();
    var tags = getProductTags(product);

    for (var i = 0; i < tags.length; i++) {
      if (tags[i].toLowerCase() === needle) return true;
    }

    return false;
  }

  function assignProductBadge(product) {
    product.badgeSrc = '';

    for (var i = 0; i < PRODUCT_BADGES.length; i++) {
      var badge = PRODUCT_BADGES[i];
      if (badge && badge.tag && badge.image && productHasTag(product, badge.tag)) {
        product.badgeSrc = badge.image;
        break;
      }
    }
  }


    var SIZE_RANK = {
    xxxxs: 1, '4xs': 1,
    xxxs: 2, '3xs': 2,
    xxs: 3, '2xs': 3,
    xs: 4,
    s: 5,
    m: 6,
    l: 7,
    xl: 8,
    xxl: 9, '2xl': 9,
    xxxl: 10, '3xl': 10,
    xxxxl: 11, '4xl': 11,
    '5xl': 12,
    '6xl': 13
  };

  function sizeValueRank(value) {
    var key = String(value || '').trim().toLowerCase().replace(/\s+/g, '');
    if (SIZE_RANK[key] != null) return SIZE_RANK[key];
    if (key !== '' && /^-?\d+(\.\d+)?$/.test(key)) return 100 + parseFloat(key);
    return 10000;
  }

  function sortSizeSwatchValues(values) {
    values.sort(function(a, b) {
      var ra = sizeValueRank(a && a.value);
      var rb = sizeValueRank(b && b.value);
      if (ra !== rb) return ra - rb;
      return String((a && a.value) || '').localeCompare(String((b && b.value) || ''), undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
  }

  function enrichProduct(product) {

    var handle = getAttributeValue(product, 'product_handle');
    var color = getAttributeValue(product, 'product_color_custom');
    var colorSlug = color ? String(color).toLowerCase().replace(/\s+/g, '-') : '';

    product.handle = handle;
    product.colorHandle = color;
    product.onSale = !!(
      product.discountPercentage &&
      product.price &&
      product.sellingPrice &&
      product.price > product.sellingPrice
    );

    product.hasColorSwatches = false;

    assignProductBadge(product);

    if (Array.isArray(product.swatches)) {
      product.swatches.forEach(function(swatch) {
        swatch.isColors = swatch.key === 'colors';
        swatch.isSizes = swatch.key === 'sizes';
        swatch.handle = handle;
        if (swatch.isSizes && Array.isArray(swatch.values)) {
          sortSizeSwatchValues(swatch.values);
        }

        if (swatch.isColors && swatch.values && swatch.values.length) {
          product.hasColorSwatches = true;
        }
      });
    }

    return product;
  }
    
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function(products) {
        products.forEach(enrichProduct);
        return products;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function(data) {
        try {
          data.response.payload.facets.forEach((facet) => {
           if (facet.key === "sellingPrice") {
               facet.data = facet.data.filter(value => value.count > 0);
           }
         });
          
        } catch (error) {
          consoel.log(error);
        }

    return data;
      });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function(data) {
        try {
          data.enforcePriceRangeFromQuery = "true";
          document.querySelector('.wizzy-search-back')?.click();
          document.querySelector('.close_search.st-search-close-icon')?.click();
    
          if(data.facets)
          {
            data.facets.forEach((facet) => {
              if(facet.key === "sellingPrice") {
                  facet.buckets = [
                    { from: 0, to: 2000 },
                    { from: 2001, to: 4000 },
                    { from: 4001, to: 6000 },
                    { from: 6001, to: 8000 },
                    { from: 8001, to: 10000 },
                    { from: 10001, to: 15000 },
                    { from: 15001, to: 20000 },
                    { from: 20001, to: 30000 },
                    { from: 30000 }
                  ];
              }
            });
          }
          const heroContent = document.querySelector(
            ".collection-hero__content-wrapper.content-position--middle-center.content-position-mobile--middle-center"
          );

          if (heroContent) {
            heroContent.style.display = "none";
          }
          document.querySelector('.shopify-section.section.section-category-list')?.style.setProperty('display', 'none');
          document.querySelectorAll('.collection-hero__inner').forEach(el => {
              el.style.display = 'none';
          });
          data.attributeFacetValuesLimit = 100;
        } catch (error) {
          console.log(error);
        }

      return data;
      },2);
            window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function(data) {
      data.enforcePriceRangeFromQuery = "true";
      return data;
      });
      window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function(data) {
      if (data.group === "defaultMenu" || data.group === "noProductsFound") {
        const categoryHandle = data?.filters?.categories?.[0];
        categoryHandle && (data.filters.sort.push({
            field: `product_${categoryHandle}_sortOrder:float`,
            order: "asc"
        }))
      }
      data.filters.attributeFacetValuesLimit = 100;
      data.filters.enforcePriceRangeFromQuery = "true";
      if (data.group === "page") {
        try {
        let filters =
          typeof data.filters === "string"
            ? JSON.parse(data.filters)
            : data.filters;

        if (
          data.group === "page" &&
          filters.sort?.length === 1 &&
          filters.sort[0].field === "relevance"
        ) {
          const alreadyExists = filters.sort.some(
            s => s.field === "product_wizzy-best-selling_sortOrder:float"
          );

          if (!alreadyExists) {
            filters.sort.push({
              field: "product_wizzy-best-selling_sortOrder:float",
              order: "asc",
            });
          }
        }

        data.filters =
          typeof data.filters === "string"
            ? JSON.stringify(filters)
            : filters;
        } catch (error) {
          console.log("error",error);
        }
      }
      return data;
      });
  
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function(data) {
          window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
              desktop: 3000
          }
        // window.wizzyConfig = window.wizzyConfig || {};
        // window.wizzyConfig.react = window.wizzyConfig.react || {};
        // window.wizzyConfig.react.enabled = true;
        // window.wizzyConfig = window.wizzyConfig || {};
        // window.wizzyConfig.ui = window.wizzyConfig.ui || {};
        // window.wizzyConfig.ui.version = 3;
        data.filters.configs.keepOpenedInMobileAfterApply = !0;
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        data.search.configs.pagination.appendInExistingList = true;
        window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";

        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.map(obj => {
            if (obj.key === "sellingPrice") {
              obj.buckets = [
                { from: 0, to: 2000 },
                { from: 2001, to: 4000 },
                { from: 4001, to: 6000 },
                { from: 6001, to: 8000 },
                { from: 8001, to: 10000 },
                { from: 10001, to: 15000 },
                { from: 15001, to: 20000 },
                { from: 20001, to: 30000 },
                { from: 30000 }
              ];
            }

            return obj;
          });
        return data;
      }
    );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function(data) {
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
              desktop: 3000
      }
        data.filters.configs.keepOpenedInMobileAfterApply = !0;
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        data.search.configs.pagination.appendInExistingList = true;
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.map(obj => {
            if (obj.key === "sellingPrice") {
              obj.buckets = [
                { from: 0, to: 2000 },
                { from: 2001, to: 4000 },
                { from: 4001, to: 6000 },
                { from: 6001, to: 8000 },
                { from: 8001, to: 10000 },
                { from: 10001, to: 15000 },
                { from: 15001, to: 20000 },
                { from: 20001, to: 30000 },
                { from: 30000 }
              ];
            }

            return obj;
          });
        window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";

      return data;
    }
  );

  var WIZZY_GRID_COOKIE = 'wizzy-grid-columns';

  function getWizzySearchWrapper() {
    return document.querySelector('.wizzy-search-wrapper');
  }

  function getDefaultWizzyGridLevel() {
    return window.innerWidth <= 989 ? 1 : 3;
  }

  function getSavedWizzyGridLevel() {
    if (typeof window.getCookie !== 'function') return null;

    var saved = window.getCookie(WIZZY_GRID_COOKIE);
    if (!saved) return null;

    try {
      var columns = JSON.parse(saved);
      var level = window.innerWidth <= 989 ? columns[0] : columns[1];
      return level ? parseInt(level, 10) : null;
    } catch (error) {
      return null;
    }
  }

  function saveWizzyGridLevel(level) {
    if (typeof window.setCookie !== 'function') return;

    var columns = [];
    if (typeof window.getCookie === 'function' && window.getCookie(WIZZY_GRID_COOKIE)) {
      try {
        columns = JSON.parse(window.getCookie(WIZZY_GRID_COOKIE));
      } catch (error) {
        columns = [];
      }
    }

    if (window.innerWidth <= 989) {
      columns[0] = level;
    } else {
      columns[1] = level;
    }

    window.setCookie(WIZZY_GRID_COOKIE, JSON.stringify(columns));
  }

  function updateWizzyGridButtons(level) {
    document.querySelectorAll('.wizzy-grid-changer button').forEach(function(button) {
      var buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'), 10);
      button.classList.toggle('active', buttonColumns === level);
    });
  }

  function applyWizzySixColCardState(level) {
    document.querySelectorAll('.wizzy-search-results-list .wizzy-result-product .card__content').forEach(function(cardContent) {
      if (level === 4 && window.innerWidth > 989) {
        cardContent.classList.add('large-up-hide');
      } else {
        cardContent.classList.remove('large-up-hide');
      }
    });
  }

  window.toggleWizzyProductGrid = function(level) {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return;

    level = parseInt(level, 10);
    wrapper.classList.add('display-tile-view');
    wrapper.setAttribute('wizzy-tile-view-level', level);
    updateWizzyGridButtons(level);
    applyWizzySixColCardState(level);
    saveWizzyGridLevel(level);

    normalizeWizzyGridLayout();
  };

  function initWizzyGridChanger() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return;

    var level = getSavedWizzyGridLevel() || getDefaultWizzyGridLevel();
    window.toggleWizzyProductGrid(level);
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function(data) {
      if (
      data &&
      data.data &&
      data.data.response &&
      data.data.response.payload &&
      data.data.response.payload.filters &&
      data.data.response.payload.filters.type === "NO_RESULTS_FOUND" &&
      document.querySelector(".custom-back-button")
  ) {
      clearButtonOnNoResultPage();
  }
        if(window.innerWidth < 768){
        const gridChanger = document.querySelector('.st-temporary-grid-changer.wizzy-grid-changer');
        const summaryWrapper = document.querySelector('.wizzy-search-summary-wrapper');
  
        if (gridChanger && summaryWrapper) {
            summaryWrapper.appendChild(gridChanger);
        }
      }
         let viewmorebuttons = document.querySelectorAll(".wizzy-autocomplete-top-products-view-more");
         let totalResults = data?.data?.response?.payload?.products?.total;
        if (viewmorebuttons.length && totalResults) {
            viewmorebuttons.forEach(button => {
                button.textContent = `View all (${totalResults}) products`;
            });
        }
        initWizzyGridChanger();
        normalizeWizzyGridLayout();
        document.querySelector('.wizzy-common-select-close')?.addEventListener('click', () => {
            document.querySelector('.wizzy-common-select-selector')?.click();
        });
        if (typeof window.bootWizzySearchUI === 'function') {
          window.bootWizzySearchUI();
        }
  
         if(window.innerWidth > 768){
        const sortWrapper = document.querySelector('.wizzy-search-sort-wrapper');
        const filterButton = document.querySelector('.wizzy-search-filters-drawer-button');
  
        if (sortWrapper && filterButton) {
            filterButton.appendChild(sortWrapper);
        }
        const gridChanger = document.querySelector('.st-temporary-grid-changer.wizzy-grid-changer');
        const filtersDrawer = document.querySelector('.wizzy-search-filters-drawer');
  
        if (
            gridChanger &&
            filtersDrawer &&
            gridChanger.parentElement !== filtersDrawer
        ) {
            filtersDrawer.appendChild(gridChanger);
        }
      }
      document.addEventListener('click', function (e) {
          const categoryChip = e.target.closest('span');
  
          if (
              categoryChip &&
              categoryChip.querySelector('.icon-category')
          ) {
              e.preventDefault();
  
              document.querySelector('.wizzy-filters-desktop-entry')?.click();
  
              const observer = new MutationObserver(() => {
                  const facetBlock = document.querySelector(
                      '.facet-block-product_product_type'
                  );
  
                  const categoryFacet = document.querySelector(
                      '.facet-head-product_product_type'
                  );
  
                  if (facetBlock && categoryFacet) {
                      observer.disconnect();
  
                      // Click only if currently collapsed
                      if (facetBlock.classList.contains('collapsed')) {
                          categoryFacet.click();
                      }
                  }
              });
  
              observer.observe(document.body, {
                  childList: true,
                  subtree: true
              });
          }
      });
  
      const total = data?.data?.response?.payload?.total || 0;
  
      const countElement = document.querySelector(
        '.st-show-result .st-show-text > span'
      );
  
      if (countElement) {
        countElement.childNodes[0].textContent = `${total} `;
      }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function(data) {
      try {
        initWizzyGridChanger();
        normalizeWizzyGridLayout();
        if (typeof window.placeCollectionSeoInWizzy === 'function') {
          window.placeCollectionSeoInWizzy();
        }
        
      } catch (error) {
        console.log(error);
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED, function(data) {
       clearButtonOnNoResultPage();
       if (typeof window.placeCollectionSeoInWizzy === 'function') {
         window.placeCollectionSeoInWizzy();
       }
     return data;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function(data) {
    try {
      
      if (
      data &&
      data.data &&
      data.data.response &&
      data.data.response.payload &&
      data.data.response.payload.filters &&
      data.data.response.payload.filters.type === "NO_RESULTS_FOUND" &&
      document.querySelector(".custom-back-button")
  ) {
      clearButtonOnNoResultPage();
  }
        if(window.innerWidth < 768){
        const gridChanger = document.querySelector('.st-temporary-grid-changer.wizzy-grid-changer');
        const summaryWrapper = document.querySelector('.wizzy-search-summary-wrapper');
  
        if (gridChanger && summaryWrapper) {
            summaryWrapper.appendChild(gridChanger);
        }
      }
         let viewmorebuttons = document.querySelectorAll(".wizzy-autocomplete-top-products-view-more");
         let totalResults = data?.data?.response?.payload?.products?.total;
        if (viewmorebuttons.length && totalResults) {
            viewmorebuttons.forEach(button => {
                button.textContent = `View all (${totalResults}) products`;
            });
        }
        initWizzyGridChanger();
        normalizeWizzyGridLayout();
        document.querySelector('.wizzy-common-select-close')?.addEventListener('click', () => {
            document.querySelector('.wizzy-common-select-selector')?.click();
        });
        if (typeof window.bootWizzySearchUI === 'function') {
          window.bootWizzySearchUI();
        }
  
         if(window.innerWidth > 768){
        const sortWrapper = document.querySelector('.wizzy-search-sort-wrapper');
        const filterButton = document.querySelector('.wizzy-search-filters-drawer-button');
  
        if (sortWrapper && filterButton) {
            filterButton.appendChild(sortWrapper);
        }
        const gridChanger = document.querySelector('.st-temporary-grid-changer.wizzy-grid-changer');
        const filtersDrawer = document.querySelector('.wizzy-search-filters-drawer');
  
        if (
            gridChanger &&
            filtersDrawer &&
            gridChanger.parentElement !== filtersDrawer
        ) {
            filtersDrawer.appendChild(gridChanger);
        }
      }
      document.addEventListener('click', function (e) {
          const categoryChip = e.target.closest('span');
  
          if (
              categoryChip &&
              categoryChip.querySelector('.icon-category')
          ) {
              e.preventDefault();
  
              document.querySelector('.wizzy-filters-desktop-entry')?.click();
  
              const observer = new MutationObserver(() => {
                  const facetBlock = document.querySelector(
                      '.facet-block-product_product_type'
                  );
  
                  const categoryFacet = document.querySelector(
                      '.facet-head-product_product_type'
                  );
  
                  if (facetBlock && categoryFacet) {
                      observer.disconnect();
  
                      // Click only if currently collapsed
                      if (facetBlock.classList.contains('collapsed')) {
                          categoryFacet.click();
                      }
                  }
              });
  
              observer.observe(document.body, {
                  childList: true,
                  subtree: true
              });
          }
      });
  
      const total = data?.data?.response?.payload?.total || 0;
  
      const countElement = document.querySelector(
        '.st-show-result .st-show-text > span'
      );
  
      if (countElement) {
        countElement.childNodes[0].textContent = `${total} `;
      }
    } catch (error) {
      console.log(error);
    }
      return data;
    }
  );

  window.addEventListener('resize', function() {
    initWizzyGridChanger();
    normalizeWizzyGridLayout();
  });


    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
    }
    const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }
      , callback = function (mutationsList, observer2) {
        for (const mutation of mutationsList) {
          updateBodyClass();
          break
        }
      }
    ,observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());

    if(window.innerWidth > 768){
    function onScroll() {
      const header = document.querySelector(".section-header");
      const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");

      if (
        header &&
        header.classList.contains("shopify-section-header-hidden") &&
        autocomplete &&
        window.getComputedStyle(autocomplete).display === "flex"
      ) {
        autocomplete.style.display = "none";
        document.body.classList.remove("wizzy-autocomplete-open");
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
  }

};
        if (window.innerWidth <= 768) {
    const front_input = document.querySelector(".st-search-icon-mobile.st-search-icon");

    front_input && front_input.addEventListener("click", function (e) {
      e.preventDefault();
      const back_input = document.querySelector("#search_mini_form input");
      back_input && back_input.click();
      let search_form = document.querySelector("#search_mini_form");
      search_form && (search_form.style.display = "block",
        setTimeout(() => {
          let search_bar = search_form.querySelector("input");
          search_bar && search_bar.click()
        }
          , 300));
    });
  }

  